export const capitalizeFirstLetter = (val) => {
  if(typeof val !== 'string' || !val.trim() || !isNaN(parseInt(val.charAt(0)))) return val
  return val ? val.charAt(0).toUpperCase() + val.slice(1) : '';
}

export const isValidURL = (string) => {
  let res = string.match(/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i);
  return (res !== null)
};

export const isEmail = (string) => {
  let res = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(string)
  return res
};

export const sendFormatter = (val) => {
  return val.trim();
}

export const getValueByNestedKey = (obj, key) => {
    const keys = key.split('.');
    let value = obj;
    for (let i = 0; i < keys.length; i++) {
      if (!value) {
        return undefined;
      }
      value = value[keys[i]];
    }
    return value;
}

export const trancateString  = (val, count = 4) => {
  if (!val) return ''
  if (val.length <= count * 2) return val

  return`${val.substr(0, count)}...${val.substr(val.length - count)}`;
}

export const formatterRecalcApproveMessage = ({ name, totalTime }) => {
    return name && totalTime ? `Updating ${name} will cause a lot of recalculations. Large number of recalculations will slow down operations. Approximate execution time is ${totalTime}. Do you want to continue?` : null
}

export const spamMessagesCombine = ({ meta, selfFunding }) => {
  if (selfFunding) {
    return 'Due to the filtering of transactions below $1 USD and the presence of only self-transactions, accessing this wallet or generating a report is impossible.'
  }

  if (meta?.spamCount && meta?.cashbackCount) {
    return 'Due to the filtering of transactions below $1 USD and the presence of only self-transactions, accessing this wallet or generating a report is impossible.'
  }

  if (meta?.cashbackCount) {
    return 'This address only contains self-transactions (transactions sent to itself), accessing this wallet or generating a report is impossible.'
  }

  if (meta?.spamCount) {
    return 'Due to the filtering of transactions below $1 USD, accessing this wallet or generating a report is impossible.'
  }
}

export const getFirstLetter = (e) => e?.charAt(0).toUpperCase() || '';

export const getLabelByDirection = (direction = 0) => {
  if (![0, 1, 2].includes(direction)) return 'label';
  return direction === 1 ? 'outLabel' : direction === 2 ? 'bothLabel' : 'label';
}

export const formatRoleName = (rawName) => {
  if (!rawName) return '';
  return rawName
    .split('_')
    .map((word, index) => index === 0
      ? word.charAt(0).toUpperCase() + word.slice(1)
      : word.toLowerCase())
    .join(' ');
}

export const pluralize = ({ count, singular, plural }) => {
  return count === 1 ? singular : plural
}

export const formatLabelsToSentence = ({ labels = [], conjunction = 'and' }) => {
  if (!Array.isArray(labels) || labels.length === 0) return ''
  if (labels.length === 1) return labels[0]

  const allButLast = labels.slice(0, -1).join(', ')
  const last = labels.at(-1)
  return `${allButLast} ${conjunction} ${last}`
}

export const getOS = () => {
  if (navigator.userAgentData && navigator.userAgentData.platform) {
    return navigator.userAgentData.platform.toLowerCase();
  }

  return navigator.userAgent.toLowerCase();
};

export const isMac = () => {
  const os = getOS();

  return os.includes('mac') || os.includes('iphone') || os.includes('ipad') || os.includes('darwin');
};

export const getNewTabHint = (action = 'click') => {
  const mac = isMac();
  const modifier = mac ? '⌘' : 'Ctrl';
  const actionLabel = action.charAt(0).toUpperCase() + action.slice(1);

  return `${modifier} + ${actionLabel} to open in a new tab`;
};


